
















































































































































import _ from 'lodash'
import { Component } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IJob } from '@/store/modules/views/job/states'
import { UserProfile } from '../../store/modules/views/userProfile/states'
import { ICenter } from '@/store/modules/views/center/states'
import { IPatient } from '@/store/modules/views/patient/states'
import { IUser } from '@/store/modules/views/user/states'
import liff from '@line/liff'

@Component
export default class Job extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }

  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private editDialog = false
  private deleteDialog = false
  private formPaymentHistoryDialog = false
  private resetDialog = false
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  get checkRole() {
    const isPermission = _.find(this.profile.permissions, (permission) => {
      return (permission.level === this.level.mode) && (permission.key === 'job') && permission.type.includes('create')
    })
    if (isPermission) {
      return true
    }
    return false
  }

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('job/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('job/itemLists')
  private itemLists!: IJob[]

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  @Getter('job/pagination')
  private pagination!: () => void

  @Getter('job/jobTypeName')
  private jobTypeName!: (period: string) => string

  @Getter('job/patientById')
  private patientById!: {[patientId: string]: IPatient}

  @Getter('job/userById')
  private userById!: {[userId: string]: IUser}

  @Getter('workingTime/periodName')
  private periodName!: (patientTypeId: string) => string

  @Action('job/getJobList')
  private getJobList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('job/getJobTypeList')
  private getJobTypeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('patient/getPatientList')
  private getPatientList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('patient/getPatientTypeList')
  private getPatientTypeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('workingTime/getWorkingTimeList')
  private getWorkingTimeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  private doTransformIconColor(value) {
    switch (value) {
      case 'สิ้นสุดบริการ': return 'green'
      case 'อยู่ระหว่างบริการ': return 'green'
      case 'การชำระเงินสำเร็จ': return 'green'
      case 'การชำระเงินถูกปฏิเสธ': return 'red'
      case 'รอตรวจสอบ': return 'yellow'
      default: return 'grey'
    }
  }

  private async getList(lists, filters = this.filters) {
    this.loadingDataTable = true
    await lists({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(filters)).toString('base64'),
        includes: 'user,patient',
      },
    })
    this.loadingDataTable = false
  }

  private async getListAll(lists, filters = {}) {
    await lists({
      headers: {
        page: 1,
        limit: 99999,
        sortBy: '_id',
        sortDesc: false,
        search: Buffer.from('').toString('base64'),
        filter: Buffer.from(JSON.stringify(filters)).toString('base64'),
      },
    })
  }

  private async getJobs() {
    await this.getList(this.getJobList)
  }

  private async getJobTypes() {
    await this.getListAll(this.getJobTypeList)
  }

  private async getPatientTypes() {
    await this.getListAll(this.getPatientTypeList)
  }

  // private async getWorkingTimes() {
  //   await this.getListAll(this.getWorkingTimeList)
  // }

  private async getAll() {
    await Promise.all([
      this.getJobs(),
      // this.getWorkingTimes(),
    ])
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(this.getAll, 1000)
  }

  private openDialog(
    job: IJob,
    modelDialog: 'editDialog' | 'resetDialog' | 'deleteDialog' | 'formPaymentHistoryDialog',
  ) {
    this.currentData = _.cloneDeep(job)
    this[modelDialog] = true
  }

  private addNewJobDialog() {
    this.createDialog = true
  }

  private openContract(job: IJob) {
    const base64 = 'data:application/pdf;base64,' + encodeURI(job.contract)
    if (liff.getOS() === 'web') {
      let win = window.open()
      if (!win) {
        win = window
      }
      win.document.write('<iframe src="' +
        base64 +
        '" frameborder="0" width="100%" height="100%" allowfullscreen ' +
        'style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"></iframe>',
      )
    } else if (liff.isInClient()) {
      liff.openWindow({
          url: `${window.location.origin}${window.location.pathname}?contract=${job._id}`,
          external: true,
      })
    } else {
      window.open(base64)
    }
    return job.contract
  }

  private download(link: string, name: string) {
    const downloadLink = document.createElement('a')
    downloadLink.href = link
    // downloadLink.target= '_blank'
    if (name) {
      downloadLink.download = name
      downloadLink.setAttribute('download', name)
    }

    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  private async mounted() {
    await Promise.all([
      this.getJobTypes(),
      this.getPatientTypes(),
      this.getAll(),
    ])
    if (this.$route.query.payment) {
      const jobId = this.$route.query.payment
      // this.$router.replace(this.$router.currentRoute.path)
      const job = _.find(this.itemLists, (item) => (item._id === jobId))
      if (!job) {
        this.updateSnackbar({txt: 'ไม่พบข้อมูลบริการ', type: 'error'})
      } else if (['รอชำระเงิน', 'การชำระเงินถูกปฏิเสธ'].includes(job.status)) {
        this.openDialog(job, 'formPaymentHistoryDialog')
      } else {
        this.updateSnackbar({txt: 'ตอนนี้สถานะของสัญญาเป็น ' + job.status, type: 'error'})
      }
    }
    if (this.$route.query.contract) {
      const jobId = this.$route.query.contract
      const job = _.find(this.itemLists, (item) => (item._id === jobId))
      if (!job) {
        this.updateSnackbar({txt: 'ไม่พบข้อมูลบริการ', type: 'error'})
      } else if (['รอชำระเงิน', 'การชำระเงินถูกปฏิเสธ'].includes(job.status)) {
        this.updateSnackbar({txt: 'ตอนนี้สถานะของสัญญาเป็น ' + job.status, type: 'error'})
      } else {
        this.openContract(job)
      }
    }
  }
}
